var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "comp_x5F_186-joomla"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "    M184.649,150c-11.538-2.164-22.154,2.159-29.503,9.507c-13.402,13.403-13.402,35.522,0,48.926l64.856,64.855",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "    M180.002,316.189c-46.977-46.765-25.706-25.834-66.376-66.422c-25.12-24.839-32.806-60.736-23.245-92.698    c-25.213-5.436-43.771-27.837-43.771-54.645c0-31.212,25.119-56.329,56.05-56.329c28.119,0,51.082,20.525,55.487,47.051    c20.272-4.726,41.329-2.934,61.253,6.855",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "    M412.666,220c9.01-20.393,9.761-41.687,3.985-61.899c27.368-3.843,48.645-27.369,48.645-55.769    c0-31.119-25.119-56.331-56.05-56.331c-28.4,0-51.926,21.089-55.768,48.364c-31.681-9.28-67.204-1.406-92.136,23.525    c-13.103,13.675-45.07,45.559-71.343,71.719",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "    M232.556,230c25.764-25.77,63.884-63.909,70.402-70.493c13.403-13.403,35.243-13.403,48.646,0    c7.548,7.548,11.905,18.585,9.313,30.494",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "    M290.006,417.274c20.704,9.049,43.799,10.05,64.69,3.547c5.154,25.683,27.838,45.084,55.207,45.084    c30.931,0,56.049-25.119,56.049-56.329c0-28.31-21.089-51.553-48.363-55.396l0,0c7.686-30.649-0.844-64.204-24.651-88.013    c-10.224-10.568,2.459,2.167-72.938-73.144",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "    M279.999,236.087l71.604,71.604c13.403,13.405,13.403,35.243,0,48.646c-7.783,7.782-19.272,12.173-31.604,9.053",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "    M280,280.109c-59.27,58.906-33.575,33.695-76.114,76.321c-13.402,13.401-35.241,13.401-48.644,0    c-6.772-6.928-10.893-16.277-10.066-26.431",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "    M92.236,300c-6.977,18.142-7.556,36.937-2.887,55.119c-25.024,5.623-43.302,28.024-43.302,54.549    c0,31.213,25.119,56.331,56.05,56.331c26.806,0,49.208-18.559,54.924-43.771c30.649,7.685,64.205-0.562,88.293-24.369    c27.561-27.476,14.224-14.367,74.686-74.869",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon5);
export default __webpack_public_path__ + "static/media/service_icon5.2f8ae48b7bd5a41f28b25973e10cd93e.svg";
export { ForwardRef as ReactComponent };